
import { menuConfig } from "../router/demo-routes";
export default {
  setup() {
    return {
      menuConfig,
    };
  },
};
